import React, { useEffect, useState, useRef } from 'react'

import { ScrollView, View, StyleSheet, Keyboard, TouchableOpacity, Text, Platform } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import {
  Description,
  Space,
  TextInputExtended,
  Button,
  Label,
  KeyboardAvoidingView,
  BasePlan,
  HorizontalLineSpacer,
  AnimatedEllipsis
} from '@sart/components'
import { adaptive, backgroundColors, colors, typography, radius } from '@sart/styles'
import client, { orderHelper, useData } from '@sart/client'
import { useContent } from '@sart/content'

import ApiClient from "../bff-client/src/ApiClient"; 
import CustomersApi from "../bff-client/src/api/CustomersApi";
import AppConfig from '../Configuration/AppConfig';
import account from './account.json'
import * as theme from '../Sign/signTheme'
import { HelpIcon } from '@sart/icons'
import { testID } from '@sart/utilities'
import { set } from 'lodash-es'

export default function CancelService(props) {
  const { navigation } = props

  const {
      customerId,
      provisionedRecurringAddOns,
    } = client.cache
    
  const [{ settings, submitting, error }, setData] = useData({ submitting: false })

  const content = useContent()



  async function handleSubmit(values, form) {
    Keyboard.dismiss()

    setData({ submitting: true, error: null })

    try {
      //SB - this is a bit ugly but we're assuming there will only be one plan per service, so just take the first item from the list
      //if the list is longer than 1, just throw an error
      
      if (provisionedRecurringAddOns?.length > 1) {
        setData({ submitting: false, error: 'Unable to process cancellation for multiple plans. Please contact support.' })
        return
      }
  
      const currentPlan = provisionedRecurringAddOns[0]
      console.log('currentPlan to be cancelled: ' + JSON.stringify(currentPlan, null, 2))
  
      navigation.navigate('CancelServiceConfirmation', {currentPlan})

      setData({ submitting: false })

    } catch (e) {
      setData({ submitting: false, error: e.message || 'An unexpected error occurred. Please try again later or contact support' })
      return
    }

  }

  async function toggleAutoRenew() {
    //{"emailAddress":"", "autoRenew":"", "bundleName":""}
    const autoRenewProducts = await client.callApi('catalog', 'getModifyServiceDetailsProducts', [client.cache.catalogId])
    const autoRenewProduct = changePlanProducts.find(product => product.productLegacyId === AppConfig.autoRenewProduct)
  }


  return (
    <SafeAreaView style={styles.container}>
      <ScrollView style={styles.scrollView}
        // ref={scrollViewRef}
        >
          <View style={styles.widthRestrictions}>
            {(provisionedRecurringAddOns && provisionedRecurringAddOns.length > 0) && 
                <>
                  <Description style={styles.subTitle}>You Have: </Description>
                  <Space height={8} />
                
                  {provisionedRecurringAddOns.map((item) => 
                    <BasePlan
                      product={item}
                      productContainer={styles.planContainer}
                      labelStyle={styles.descriptionStyle}
                      nameStyle={styles.descriptionContentStyle}
                      textStyle={styles.dateStyle}
                      productName={item.product.productName}
                      price={item.product.upfrontCost}
                      // language={language}
                      injectedContent={content}
                      code={item.product.currency}
                      showToggle={false}
                    />
                  )}
                  <Space height={16} />
          

                  <HorizontalLineSpacer color={colors.white} />

                  <Description style={styles.subTitle}>{content.cancel.info}</Description>
                  <Space height={40} />

                  <Button
                    title={
                      submitting
                        ? <AnimatedEllipsis style={{fontSize:24, color:colors.clear, ...typography.extrabold}}/>
                        : content.cancel.buttonLabel
                    }
                    disabled={submitting}
                    onPress={handleSubmit}
                    style={styles.enabledButton}
                    disabledStyle={styles.disabledButton}
                    titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
                    disabledTitleStyle={{...typography.extrabold, fontSize: 18, color: colors.white + 45}}  
                    {...testID('cancelServiceSubmit')}      
                  />
              </>
          }
          {!(provisionedRecurringAddOns && provisionedRecurringAddOns.length > 0) &&
            <>
              <Description style={styles.descriptionStyle}>{content.cancel.noPlan}</Description>
              <Space height={16} />
            </>
          }
        </View>
        
      </ScrollView>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 24,
    paddingBottom: 0,
    backgroundColor: backgroundColors.darkCharcoal,
    ...adaptive.wrapperPadding,
    width: '100%',
    ...Platform.select({
      web: {
        alignItems: 'center'
      }
    })
  },
  scrollView: {
    //height: '100%',
    //width: '100%',
    //alignItems: 'center'
  },
  dateStyle: {
    fontSize: 16,
    lineHeight: 22,
    color: colors.white,
    ...typography.demi
  },
  planContainer: {
      padding: 12,
      backgroundColor: backgroundColors.darkCharcoal,
      borderRadius: radius.medium,
      elevation: 8,
      // ...shadows.shadowByElevation(8),
      borderColor: colors.white,
      borderWidth: 1
  },
  priceStyle: {
    fontSize: 16,
    lineHeight: 48,
    fontWeight: '700',
    color: colors.white
  },
  descriptionStyle: {
    fontSize: 16,
    lineHeight: 26,
    color: colors.white,
    ...typography.demi,
  },
  descriptionnNoPlanStyle: {
    fontSize: 16,
    lineHeight: 16,
    color: colors.srTextInput,
    ...typography.demi,
  },
  descriptionContentStyle: {
    fontSize: 16,
    lineHeight: 24,
    color: colors.white,
    ...typography.demi
  },
  description: {
    textAlign: 'center',
    ...typography.lightbold,
    color: colors.brightOrange
  },
  selectStyle: {
    ...typography.demi
  },
  curpFooter: {
    ...typography.demi,
    color: colors.brightOrange,
    alignContent: 'flex-end',
    textDecorationLine: 'underline'
  },
  inputWrapper: {
    flexDirection: 'row',
  },
  nestedInputs: {
    flex: 1
  },
  inputStyle: {
    height: 300
  },
  enabledButton: {
    backgroundColor: colors.brightOrange,
  },
  disabledButton: {
    backgroundColor: colors.brightOrange + 50
  },
  label: {
    color: colors.brightOrange,
    ...typography.lightbold,
    fontSize: 16
  },
  helpIcon: {
    justifyContent: 'center'
  },
  helpPointContainer: {
  },
  helpPointText: {
    ...typography.medium,
    color: colors.brightOrange,
    fontSize: 14
  },
  noId: {
    ...typography.demi,
  },
  labelStyles: {
    color: colors.brightOrange,
    ...typography.demi
  },
  enabled: {
    backgroundColor: colors.brightOrange
  },
  disabled: {
    backgroundColor: colors.brightOrange + 60,
    borderColor: colors.brightOrange + 60,
    borderWidth: 1
  },
  subTitle: {
    ...typography.lightbold,
    color: colors.white,
    fontSize: 14,
  },
  widthRestrictions: {
    width: '100%',
    maxWidth: 600
  }
})

const selectStyle = {
  control: (base) => ({
    ...base,
    ...typography.demi,
  }),
  menu: (base) => ({
    ...base,
    ...typography.demi
  })
};